import { Chip } from "@octopusdeploy/design-system-components";
import { FolderIcon, HelmIcon } from "@octopusdeploy/design-system-icons";
import type { ArgoCDApplicationSourceResource } from "@octopusdeploy/octopus-server-client";
import { isHelmApplicationSource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { ChipIconWrapper } from "~/components/Chips/ChipIconWrapper";
type SourceTypeChipProps = {
    source: ArgoCDApplicationSourceResource;
};
export const SourceTypeChip = (props: SourceTypeChipProps) => {
    const { source } = props;
    if (isHelmApplicationSource(source)) {
        return (<Chip label={"Helm"} noMargin icon={<ChipIconWrapper>
                        <HelmIcon size={16}/>
                    </ChipIconWrapper>}/>);
    }
    else {
        return (<Chip label={"Directory"} noMargin icon={<ChipIconWrapper>
                        <FolderIcon size={16}/>
                    </ChipIconWrapper>}/>);
    }
};
